import { render, staticRenderFns } from "./completedList.vue?vue&type=template&id=1c909dd5&scoped=true&"
import script from "./completedList.vue?vue&type=script&lang=js&"
export * from "./completedList.vue?vue&type=script&lang=js&"
import style0 from "./completedList.vue?vue&type=style&index=0&id=1c909dd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c909dd5",
  null
  
)

export default component.exports